import * as React from "react";

export const IconClose = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="1em" height="1em" viewBox="0 0 32 32" fill="currentColor" {...props}>
    <path d="M8.23047 8L24.0003 23.8841" stroke="currentColor" strokeWidth="2" />
    <path d="M8 24L23.7698 8.11594" stroke="currentColor" strokeWidth="2" />
  </svg>
);
